<h2 class="text-white mb-2" *ngIf="isTransferPage">
  {{ 'payment.history.page.transfer.title' | translate }}
</h2>

<div class="card border" [ngClass]="isKid ? 'mt-0' : 'mt-3 mt-lg-0'">
  <div [ngClass]="{ 'card-body-ecash': ecashView, 'card-body-account': accountView }">
    <div class="d-flex flex-column flex-lg-row justify-content-lg-between">
      <fgbcl-date-range-picker [(startDate)]="transactionStartDate" [(endDate)]="transactionEndDate"></fgbcl-date-range-picker>
      <button type="button" class="search-button rounded fw-bold mb-2 d-block text-white bg-primary" (click)="search()">
        Search
      </button>
    </div>
  </div>
</div>

<fgb-transaction-list
  *ngIf="selectedValues"
  [startDate]="selectedValues.start"
  [endDate]="selectedValues.end"
  [memberId]="memberId"
  [transactionType]="selectedValues.type"
  [isTransferPage]="isTransferPage"
></fgb-transaction-list>
